// extracted by mini-css-extract-plugin
module.exports = {"locales":"_1J2-zMrFR1GBTm8JW6KnJt","locale":"_3Y6yDVgbDVZcq_y5fO5zFP","active":"_2AsAK0rxzHyEcuCbTlu4TX"};